/**
 * Calculates distances from all edges of an element to the corresponding viewport edges.
 * @param {HTMLElement} element - The DOM element to measure.
 * @returns {Object} Object containing all four distances.
 */
export const getElementViewportDistances = (element) => {
  const rect = element.getBoundingClientRect();
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  return {
    top: rect.top, // Distance from element top to viewport top
    bottom: viewportHeight - rect.bottom, // Distance from element bottom to viewport bottom
    left: rect.left, // Distance from element left to viewport left
    right: viewportWidth - rect.right, // Distance from element right to viewport right
  };
};

/**
 * Calculates distances from all edges of an element to the edges of a container element
 * @param {HTMLElement} element - The inner element to measure
 * @param {HTMLElement} container - The container element to measure against
 * @returns {Object} Object containing top, bottom, left, and right distances
 */
export const getElementDistancesWithinContainer = (element, container) => {
  const elementRect = element.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  return {
    top: elementRect.top - containerRect.top,
    bottom: containerRect.bottom - elementRect.bottom,
    left: elementRect.left - containerRect.left,
    right: containerRect.right - elementRect.right,
  };
};
